import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { oktaConfig } from './config/oktaConfig';
import { useNavigate } from 'react-router-dom';

import Layout from './components/layout/Layout';
import AuthorizedLayout from './components/layout/authorizedLayout/AuthorizedLayout';

export const oktaAuth = new OktaAuth(oktaConfig);

const App = () => {
  const navigate = useNavigate();


  const restoreOriginalUri = (_oktaAuth: any, originalUri: any) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin));
  };

  const onAuthRequired = function () {
    navigate('/login');
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri} onAuthRequired={onAuthRequired}>
      {/* <Layout isAuthenticated={true} /> */}
      <AuthorizedLayout />
    </Security>
  );
};

export default App;
